var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccordion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1854 8.2718L11.3707 0.916844C10.6006 0.192043 9.39937 0.192043 8.62927 0.916843L0.814633 8.27179C0.412459 8.65031 0.39328 9.28318 0.771797 9.68536C1.15031 10.0875 1.78319 10.1067 2.18536 9.72819L10 2.37324L17.8146 9.7282C18.2168 10.1067 18.8497 10.0875 19.2282 9.68536C19.6067 9.28319 19.5875 8.65031 19.1854 8.2718Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccordion);
export default __webpack_public_path__ + "static/media/ic_accordion.f052b661c53721725c43fd86c56362fa.svg";
export { ForwardRef as ReactComponent };